import React from 'react';
import styled from 'styled-components';

const FillerDiv = styled.div`
	display: flex;
	flex-grow: 1;
	flex-basis: 1px;
`;

export const Filler = () => <FillerDiv />;